import { CommandItem } from '@/code/frontend/components/ui/command';
import { EMPLOYEE_LOOKUP_COMMANDS } from '../constants';

const TRUNCATED_ID_LENGTH = 12;

interface CmdKLookupResultItemProps {
  lookupType: string;
  id: string;
  name: string;
  onSelect: () => void;
}

/**
 * A single lookup result item (campaign, user, etc.) in the CmdK dialog.
 */
export function CmdKLookupResultItem({
  lookupType,
  id,
  name,
  onSelect,
}: CmdKLookupResultItemProps) {
  const command = EMPLOYEE_LOOKUP_COMMANDS.find(
    (c) => c.prefix.toLowerCase() === `${lookupType}:`,
  );
  const Icon = command?.icon;
  const isImpersonate = lookupType === 'impersonate';

  return (
    <CommandItem
      value={`result-${lookupType}-${id}`}
      onSelect={onSelect}
      className="flex items-center gap-3"
    >
      {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      <div className="flex-1 min-w-0">
        <span className="truncate">{name}</span>
        <span className="text-muted-foreground ml-2 text-xs font-mono">
          {id.slice(0, TRUNCATED_ID_LENGTH)}...
        </span>
      </div>
      {isImpersonate && (
        <span className="flex shrink-0 items-center gap-1">
          <kbd className="px-1.5 py-0.5 rounded bg-muted font-mono text-xs text-muted-foreground">
            ⏎
          </kbd>
          <kbd className="px-1.5 py-0.5 rounded bg-muted font-mono text-xs text-muted-foreground">
            ⌘⏎
          </kbd>
        </span>
      )}
    </CommandItem>
  );
}
